

class SelectControlController {
    constructor() {
    }
}

export default SelectControlController;



// WEBPACK FOOTER //
// ./client/app/common/select-control/select-control.controller.js